
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, ResponsiveContainer } from 'recharts';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import ChartLegend from '@/components/charts/ChartLegend';

interface DeviceStatusChartProps {
  chartData: any[];
  hiddenLines: string[];
  onLegendClick: (dataKey: string) => void;
  deviceType: 'smartMeters' | 'gateways';
}

const DeviceStatusChart: React.FC<DeviceStatusChartProps> = ({
  chartData,
  hiddenLines,
  onLegendClick,
  deviceType
}) => {
  // Custom legend renderer
  const renderLegend = (props: any) => {
    return (
      <ChartLegend 
        payload={props.payload} 
        hiddenLines={hiddenLines} 
        onLegendClick={onLegendClick}
      />
    );
  };

  const title = `${deviceType === 'smartMeters' ? 'Smart Meter' : 'Gateway'} Status Trend`;
  const prefix = deviceType === 'smartMeters' ? 'smartMeters' : 'gateways';

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="h-80">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart
              data={chartData}
              margin={{
                top: 5,
                right: 30,
                left: 20,
                bottom: 5,
              }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <RechartsTooltip />
              <Line 
                type="monotone" 
                dataKey={`${prefix}Online`} 
                name="Online" 
                stroke="#10b981" 
                activeDot={{ r: 8 }} 
                hide={hiddenLines.includes(`${prefix}Online`)}
              />
              <Line 
                type="monotone" 
                dataKey={`${prefix}Warning`} 
                name="Warning" 
                stroke="#f59e0b" 
                hide={hiddenLines.includes(`${prefix}Warning`)}
              />
              <Line 
                type="monotone" 
                dataKey={`${prefix}Critical`} 
                name="Critical" 
                stroke="#ef4444" 
                hide={hiddenLines.includes(`${prefix}Critical`)}
              />
              <Line 
                type="monotone" 
                dataKey={`${prefix}Offline`} 
                name="Offline" 
                stroke="#6b7280" 
                hide={hiddenLines.includes(`${prefix}Offline`)}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default DeviceStatusChart;
